import { DefaultTable } from 'src/app/models/table-patterns';
import { FieldConfig } from '../../models/form-field.model';
import { FormConfigInstance } from '../../services/form.service';


export class ListPickerOption<T = any> extends DefaultTable {
  title: string;
  lines: string[];
  value: T;
  icon?: {
    engine: 'mat' | 'fa';
    icon: string;
  };
  action?: () => boolean;

  constructor(o?: Partial<ListPickerOption>) {
    super(o);
  }
}

export class ListPickerSection<T = any> extends DefaultTable {
  title: string;
  options: ListPickerOption<T>[];
  constructor(o?: Partial<ListPickerSection>) {
    super(o);
  }
}


export class FormListPickerField<T = any> extends FieldConfig<T>{
  listType: 'selection' | 'multiSelection' | 'action';
  selected?: (item: T, service: FormConfigInstance) => boolean;
  options: ListPickerOption<T>[];
  sections: ListPickerSection[];
  styles?: {
    list?: any,
    option?: any,
  }
  constructor(o?: Partial<FormListPickerField<T>>) {
    super(o);
    this.type = 'listPicker';
    if (this.options) {
      this.options = this.options.map(_ => new ListPickerOption<T>(_));
    }
  }
}
